var _style, _path, _path2, _circle;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTerra = function SvgTerra(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0E3CA5;}\n\t.st1{fill:#5493F7;}\n\t.st2{display:none;opacity:0.3;fill:#FF1A82;enable-background:new    ;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.4,62.1c-4.2-15.5,29.7-23.3,32.8-23.5c8.7,0.2,10.8,10.5,4.4,21.1c-8.2,13.7-23.1,16.4-23.2,16.4 C44.5,76.4,36.6,70.2,34.4,62.1 M66.4,10C66.4,10,66.4,10,66.4,10L66.4,10C59.8,4.4,51.2,1,41.8,1c-5.5,0-10.7,1.2-15.4,3.3 C25.6,4.6,24.8,5,24,5.4c-0.5,0.3-1.1,0.6-1.6,0.9l0.1,0c-1.6,1.1-2.9,2.3-4,3.8C7.7,24.5,44.2,35,63.7,35 C72.7,41.5,75.2,16.9,66.4,10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.6,10.3c-5,7.5-21.7,12.9-24.5,12c0,0,0,0,0,0c0.1-0.2,0.2-0.5,0.3-0.7c0.9-1.8,2-3.6,3.2-5.2s2.6-3.2,4-4.7 s3-2.8,4.7-4c1-0.8,2.1-1.5,3.2-2.1c2.3-1.3,4.7-1.4,5.5-1.5C32.5,4.3,28.6,10.2,28.6,10.3 M24.5,63.6c-0.4-2.4-1.1-7.3-5.8-15.3 c-0.8-1.3-4.5-7.3-7.2-11C8.7,33.5,5.3,30,2.5,26.2l0,0C2.3,26.6,2.2,27,2,27.4c-0.7,2-1.2,4-1.5,6.2S0,37.8,0,40s0.2,4.4,0.5,6.5 s0.9,4.2,1.5,6.2s1.5,3.9,2.4,5.7s2,3.6,3.2,5.2c1.2,1.6,2.6,3.2,4,4.7c1.4,1.4,3,2.8,4.7,4c1.2,0.9,2.5,1.7,3.8,2.5 c2.5,1.4,3.4,1.4,3.8,1.3C24.5,75.3,24.9,66,24.5,63.6 M80,40c0-12-5.3-22.8-13.7-30.1c-2.5-2-6.7-2.1-8.1-2.1 C46.5,8.2,20,17.3,21.7,30.4c1.2,9.1,14.4,14.9,18.8,16.8c0.3,0.1,32.1,12.6,36.8,7.5C79,50.2,80,45.2,80,40 M58.5,75.5 c6.8-3.6,12.5-9.1,16.3-15.8c0.2-0.3,0-0.7-0.4-0.6c-3.7,0.4-20.3,7-22.2,13.5C51.2,75.9,55,77.1,58.5,75.5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 40,
    cy: 40,
    r: 40
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTerra, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Terra.7887bf5a.svg";
export { ForwardRef as ReactComponent };